import { ApplicationState } from "../applicationState";

export const customerDocumentsSelector = (state: ApplicationState) =>  {
    return state.customerDocuments;
};
